export default __webpack_public_path__ + "static/eduhklib-logo-0f202ea34688e5df99f8cda605a09e7c.jpeg";